import React from 'react'
import ProjectContainer from '../components/ProjectContainer'

function Homepage() {
    return (
        <div>
            <ProjectContainer />
        </div>
    )
}

export default Homepage